<template>
  <div class="row">
    <div class="col-lg">
      <ValidationField class="form-group mb-3" v-bind="$attrs" :value="modelValue" highlight>
        <template v-slot:default>
          <label :for="id">
            {{ $t(`${scope}.labels.${name}`) }}
            <span class="fw-normal" v-if="!noRequiredLabel">({{ $t('form.required') }})</span>
          </label>
          <input
            :type="type"
            class="form-control form-control-lg"
            :id="id"
            :name="`${scope}.${name}`"
            :value="modelValue"
            :disabled="$attrs.disabled"
            @input="$emit('update:modelValue', $event.target.value)"
          >
        </template>
        <template v-slot:error>
          <div class="invalid-feedback">{{ $t(`${scope}.validation.${name}`) }}</div>
        </template>
      </ValidationField>
    </div>
    <div class="col-lg">
      <ValidationField class="form-group mb-3" v-bind="$attrs" :value="confirmValue" :equal-to="modelValue" highlight>
        <template v-slot:default>
          <label :for="`confirm-${id}`">
            {{ $t(`${scope}.labels.${name}Confirmation`) }}
            <span class="fw-normal" v-if="!noRequiredLabel">({{ $t('form.required') }})</span>
          </label>
          <input
            :type="type"
            class="form-control form-control-lg"
            :name="`${scope}.${name}.confirm`"
            :id="`confirm-${id}`"
            :disabled="$attrs.disabled"
            v-model.trim="confirmValue"
          >
        </template>
        <template v-slot:error>
          <div class="invalid-feedback">{{ $t(`${scope}.validation.${name}Confirmation`) }}</div>
        </template>
      </ValidationField>
    </div>
  </div>
</template>

<script>
import ValidationField from './ValidationField';

let index = 0;

export default {
  props: {
    scope: { type: String, required: true },
    name: { type: String, required: true },
    type: { type: String, default: 'text' },
    withPlaceholder: { type: Boolean, default: true },
    modelValue: String,
    noRequiredLabel: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  components: {
    ValidationField,
  },
  data() {
    return {
      confirmValue: '',
    };
  },
  computed: {
    id() {
      return [this.scope, this.type, this.name, ++index].join('-');
    },
  },
};
</script>
